import {memo, PropsWithChildren} from 'react';
import {Header} from '../Header/Header';
import styles from './Layout.module.scss';
import Menu from './Menu/Menu';
import {LayoutProps} from './types';
import {Outlet} from 'react-router-dom';

const _Layout = ({hasSidebar, children, style}: PropsWithChildren<LayoutProps>) => {
    return (
        <>
            <div className={styles.wrapper}>
                <div id='app-header'>
                    <Header />
                </div>
                {hasSidebar && <Menu />}
                <main
                    id='app-content'
                    className={styles.content}
                    style={style}
                >
                    {children ? children : <Outlet />}
                </main>
            </div>
        </>
    );
};

export default memo(_Layout);
